/**
 * AddressAutocompleteInput — a single-string address input with Google Places
 * suggestions. Calls onChange(value) on every keystroke AND when a place is
 * selected (with the formatted address), so the parent keeps one string value.
 *
 * Reused by the Commercial Account page for HQ + per-location addresses.
 */
import React from 'react';
import PlacesSuggestInput from './PlacesSuggestInput';

export default function AddressAutocompleteInput({
    value, onChange, placeholder = 'Type and select an address', size = 'sm', ...rest
}) {
    return (
        <PlacesSuggestInput
            value={value}
            onChange={onChange}
            onSelect={({ formattedAddress }) => onChange(formattedAddress)}
            placeholder={placeholder}
            size={size}
            {...rest}
        />
    );
}
